import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteSharp from "@mui/icons-material/DeleteSharp";
import i18n from "./i18n";
import { normalizeLocaleFromPathname } from "./i18n/locales";

export default function AlertDialog(props) {
  const { itemTitle, onConfirm, locale: localeProp } = props;
  const locale = localeProp || normalizeLocaleFromPathname(window.location.pathname);
  const t = (key, options) => i18n.t(key, { lng: locale, ...options });

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRemove = () => {
    onConfirm();
    setOpen(false);
  };

  return (
    <div className="dropchance-item__icon-container dropchance-item__icon-container--trash">
      <div className="dropchance-item__icon--trash" onClick={handleClickOpen}>
        <DeleteSharp />
      </div>
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth={true}>
        <DialogTitle id="alert-dialog-title">{t("dialog.removeTitle")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {itemTitle
              ? t("dialog.confirmRemove", { title: itemTitle })
              : t("dialog.confirmRemoveEmpty")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="button button--gray" onClick={handleClose}>
            {t("dialog.cancel")}
          </div>
          <div className="button button--red" onClick={handleRemove}>
            {t("dialog.remove")}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
